// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"style_tableWrapper__SdfoS","tableTitle":"style_tableTitle__34P_C"};